import { render, staticRenderFns } from "./Competitions.vue?vue&type=template&id=689e8fe3&scoped=true"
import script from "./Competitions.vue?vue&type=script&lang=js"
export * from "./Competitions.vue?vue&type=script&lang=js"
import style0 from "./Competitions.vue?vue&type=style&index=0&id=689e8fe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e8fe3",
  null
  
)

export default component.exports